import { action } from "typesafe-actions";
import ActionTypes from "./constants";
import {SearchResultElementType} from "../../types/product";
import {AppParametersType} from "../../types/app";

export const resetSearchAction = () => action(ActionTypes.RESET_SEARCH);

export const changeRoutineStatusAction = (status) => action(ActionTypes.CHANGE_ROUTINE_STATUS, status);

export const removeSearchResultDetailsAction = () => action(ActionTypes.REMOVE_SEARCH_RESULT_DETAILS);

export const showProductDetailsAction = () => action(ActionTypes.SHOW_PRODUCT_DETAILS);

export const hideProductDetailsAction = () => action(ActionTypes.HIDE_PRODUCT_DETAILS);

export const storeFormDataPayloadAction = (data) => action(ActionTypes.STORE_FORMDATA_PAYLOAD, data);

export const updateFormDataPayloadAction = (data) => action(ActionTypes.UPDATE_FORMDATA_PAYLOAD, data);

export const resetSearchFiltersSelectedAction = () => action(ActionTypes.RESET_SEARCH_FILTERS_SELECTED);

export const updateSearchFiltersSelectedAction = (data) => action(ActionTypes.UPDATE_SEARCH_FILTERS_SELECTED, data);

export const resetProductionFiltersSelectedAction = () => action(ActionTypes.RESET_PRODUCTION_FILTERS_SELECTED);

export const updateProductionFiltersSelectedAction = (data) => action(ActionTypes.UPDATE_PRODUCTION_FILTERS_SELECTED, data);

export const initProcessFiltersSelectedAction = () => action(ActionTypes.INIT_PROCESS_FILTERS_SELECTED);

export const updateProcessFiltersSelectedAction = (data) => action(ActionTypes.UPDATE_PROCESS_FILTERS_SELECTED, data);

export const toggleFirstPartSidebarAction = (flag) => action(ActionTypes.TOGGLE_SIDEBAR_FIRSTPART, flag);

export const toggleSecondPartSidebarAction = (flag) => action(ActionTypes.TOGGLE_SIDEBAR_SECONDPART, flag);

export const toggleSidebarProcessingParametersAction = (flag) => action(ActionTypes.TOGGLE_SIDEBAR_PROCESSING_PARAMS, flag);

export const setActiveTabOnLeftSidebarAction = (value) => action(ActionTypes.SET_ACTIVE_TAB_ON_LEFT_SIDEBAR, value);

export const setMissionAction = (mission) => action(ActionTypes.SET_MISSION, mission);

export const setMultiMissionAction = (missionCodes) => action(ActionTypes.SET_MULTI_MISSION, missionCodes);

export const toggleProductCategoryFlagAction = (flag) => action(ActionTypes.TOGGLE_PRODUCT_CATEGORY_FLAG, flag);

export const setApplicationErrorAction = (error: string) => action(ActionTypes.SET_APPLICATION_ERROR, error);

export const storeInitialDataSuccessAction = (data) => action(ActionTypes.STORE_INITIAL_DATA_SUCCESS, data);

export const storeInitialDataStartedAction = () => action(ActionTypes.STORE_INITIAL_DATA_STARTED);

export const storeSearchResultDetailsAction = (searchResultDetails: SearchResultElementType) => action(ActionTypes.STORE_SEARCH_RESULT_DETAILS, searchResultDetails);

export const setAppParametersAction = (appParameters: AppParametersType | null) => action(ActionTypes.SET_APP_PARAMETERS, appParameters);

export const setCurrentPageAction = (currentPage: number) => action(ActionTypes.SET_CURRENT_PAGE, currentPage);

export const setCurrentMasterItemAction = (currentPage: number) => action(ActionTypes.SET_CURRENT_MASTER_ITEM, currentPage);
